module.exports = __webpack_public_path__ + "img/bs.9de94cbc.svg";